import * as React from 'react'

const ResroreFromArchive = (props: any) => (
  <svg {...props} viewBox='0 0 16 20' fill='#fff' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M11.0925 2.52427L11.3419 3.40544H4.6643L4.91252 2.52427H11.0925ZM4.18584 5.10369H11.8226L11.5258 4.05515H4.48122L4.18584 5.10369ZM3.10375 5.10369L4.11518 1.5534H11.8888L12.905 5.10369H14.5153L13.0411 0H2.96371L1.486 5.10369H3.10375ZM0 6.30027L0.823915 10.5437H15.1761L16 6.30027H0ZM9.22451 8.7233H6.77549C6.4935 8.7233 6.26477 8.49511 6.26477 8.21359C6.26477 7.93208 6.4935 7.70388 6.77549 7.70388H9.22451C9.5065 7.70388 9.73519 7.93208 9.73519 8.21359C9.73519 8.49511 9.5065 8.7233 9.22451 8.7233Z'
      transform='translate(0 9)'
      fill='#666666'
    />
    <path d='M4 0L8 4H0L4 0Z' transform='translate(4)' fill='#666666' />
    <rect width='2' height='6' transform='translate(7 2)' fill='#666666' />
  </svg>
)

export default ResroreFromArchive



// WEBPACK FOOTER //
// ./src/components/icons/drivers/RestoreFromArchive.tsx